export default __webpack_public_path__ + "static/media/bootstrap web.5e0d5c90.png";